import { UseCaseInteractor } from '../../../kernel/use-case'
import { AuthRepository } from '../domain/auth.repository'

export const setPermissionsStytchUseCase: UseCaseInteractor<[authRepository: AuthRepository], [], void> =
  (authRepository: AuthRepository) => async (): Promise<void> => {
    return authRepository.setPermissionsStytch()
  }
